module.exports = __webpack_public_path__ + "img/shopee_9thb_0003.14e73422.png";